import { InputHTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>((props, ref) => {
  return (
    <input
      {...props}
      ref={ref}
      className={twMerge(
        'focus:outline-none border-b border-b-border border-solid border-opacity-50 p-2.5 bg-transparent text-lg',
        'disabled:text-gray-500 disabled:cursor-not-allowed',
        props.className
      )}
    />
  )
})

export default Input
